import React, { useState, useEffect, useContext } from "react";
import { PanelSelector } from "../components/PanelSelector";
import { StoreContext } from "../store/Store";
import { TaskFilterPanel } from "./style/TaskFilterPanel";
import { InstructionFilterPanel } from "./style/InstructionFilterPanel";
import { QuestionFilterPanel } from "./style/QuestionFilterPanel";
import { ButtonFilterPanel } from "./style/ButtonsFilterPanel";
import { SelectFilterPanel } from "./style/SelectFilterPanel";
import { LabelsFilterPanel } from "./style/LabelsFilterPanel";
import { MarkersFilterPanel } from "./style/MarkersFilterPanel";
import { DragNodeFilterPanel } from "./style/DragNodeFilterPanel";
import { StartFilterPanel } from "./style/StartFilterPanel";
import { PopupFilterPanel } from "./style/PopupFilterPanel";
import { PopupLabelFilterPanel } from "./style/PopupLabelFilterPanel";
import { UndoButtonFilterPanel } from "./style/UndoButtonFilterPanel";
import { UploadFilterPanel } from "./style/UploaFilterPanel";
import { HandleFilterPanel } from "./style/HandleFilterPanel";
import { getConfigs } from "../api/s3";

const panels = [
  "screenshot",
  "end",
  "question",
  "start",
  "select",
  "buttons",
  "edge",
  "handle",
  "marker",
  "popup",
  "popup label",
  "undo button",
  "drag node",
  "upload",
];

export const Style = () => {
  const [panel, setPanel] = useState("screenshot");

  const [store] = useContext(StoreContext);
  const { auth, showStyle, mode } = store;

  useEffect(() => {
    // load default config
    const asyncfunction = async () => {
      const defConfig = await getConfigs(auth, "D2Legal");
      if ("Item" in defConfig) {
        setFilter(defConfig["Item"]);
      }
    };
    asyncfunction();
  }, [auth]);

  const [filter, setFilter] = useState();

  const ChoosePanel = (panel) => {
    switch (panel) {
      case "screenshot": {
        return <TaskFilterPanel />;
      }
      case "end": {
        return <InstructionFilterPanel />;
      }
      case "question": {
        return <QuestionFilterPanel />;
      }
      case "start": {
        return <StartFilterPanel />;
      }
      case "edge": {
        return <LabelsFilterPanel />;
      }
      case "marker": {
        return <MarkersFilterPanel />;
      }
      case "buttons": {
        return <ButtonFilterPanel />;
      }
      case "select": {
        return <SelectFilterPanel />;
      }
      case "popup":
        return <PopupFilterPanel />;
      case "popup label": {
        return <PopupLabelFilterPanel />;
      }
      case "undo button":
        return <UndoButtonFilterPanel />;
      case "drag node":
        return <DragNodeFilterPanel />;
      case "handle":
        return <HandleFilterPanel />;
      case "upload":
        return <UploadFilterPanel />;
      default:
        return null;
    }
  };

  return filter && showStyle && mode === "layout" ? (
    <div
      style={{
        fontFamily: "Graphic",
        fontSize: 12,
        fontWeight: 400,
        position: "absolute",
        right: 10,
        top: 0,
        width: "360px",
        height: "100%",
        zIndex: 10,
        backgroundColor: "#ffffff",
      }}
    >
      <div>
        <PanelSelector
          panel={panel}
          setPanel={setPanel}
          panels={panels}
          configId="D2Legal"
        />
        {ChoosePanel(panel)}
      </div>
    </div>
  ) : null;
};
